module.exports = __webpack_public_path__ + "images/6c2a895a7ff234e0ed4905d149af49db.jpg";